import { render, staticRenderFns } from "./BusinessRegistrationApplications.vue?vue&type=template&id=226818f0&scoped=true&"
import script from "./BusinessRegistrationApplications.vue?vue&type=script&lang=js&"
export * from "./BusinessRegistrationApplications.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRegistrationApplications.vue?vue&type=style&index=0&id=226818f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226818f0",
  null
  
)

export default component.exports